import { i18NextInit } from '@egw/i18n'
import en from './en.json'

i18NextInit(
  {
    en: {
      common: en,
    },
  },
  'en',
  {
    useBackend: false,
  },
)
  .then(() => {
    // log.debug('i18n initialized')
  })
  .catch((error: unknown) => {
    // log.error('i18n initialization failed', error)
  })
